import classNames from 'classnames';
import { ServiceType } from '../../codegen/vehicles';

type ServiceIconProps = {
  service: ServiceType;
  className?: string;
};

const serviceTypesToIcon: { [key in ServiceType]: string } = {
  FUELING: 'rioglyph rioglyph-filling-station',
  BREAKDOWN: 'rioglyph rioglyph-workshop',
  PARKING: 'rioglyph rioglyph-parking',
  WASHING: 'rioglyph rioglyph-stars',
  CHARGING: 'rioglyph rioglyph-filling-e-station',
  OTHER: 'rioglyph rioglyph-shopping-cart',
};

export const ServiceIcon = ({ service, className }: ServiceIconProps) => (
  <span className={classNames(serviceTypesToIcon[service], className)} />
);
